import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './header.css';
import logo from '../../assets/logo.png'

const Header = () => {
    return (
        <div className='gpt3__header section__padding' id='home'>
            <motion.div
                className='gpt3__header-content'
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
            >
                <h1 className='gradient__text'>Advanced ECU Control Starts Here. Precision Tuning Without Limits.</h1>

                <p>Prinzetuner is a professional ECU file processing platform built for advanced IMMO OFF and system-level modifications. <br /><br />Built for professionals. Engineered for precision.</p>

                <div className='gpt3__header-content__buttons'>
                    <a href="/#products">
                        <button type="button" className="btn-primary">Buy a Product</button>
                    </a>
                    <a href="https://wa.me/966590707424" target="_blank" rel="noreferrer">
                        <button type="button" className="btn-secondary">Build ECU Tuning Software</button>
                    </a>
                </div>

                <div className='gpt3__header-content__file-service'>
                    <Link to="/file-service">
                        <button type="button" className="btn-file-service">File Service</button>
                    </Link>
                </div>
            </motion.div>
            <motion.div
                className='gpt3__header-image'
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
            >
                <div className="gpt3__header-image_logo">
                    <img src={logo} alt="Prinze Tuner Professional ECU Solutions Neon Logo" className="neon-logo" loading="lazy" />
                </div>
            </motion.div>
        </div>
    )
}

export default Header
